export const actions = {
  SET_PASSCODE_VALIDATED: 'config/SET_EMPLOYEE_VALIDATED',
  SET_ADMIN_PASSCODE: 'config/SET_ADMIN_PASSCODE',
  SET_FIRST_TIME_CLOCKING_IN: 'config/SET_FIRST_TIME_CLOCKING_IN',
  SET_MAGIC_LINK: 'config/SET_MAGIC_LINK',
};

export function setPasscodeValidated() {
  return {
    type: actions.SET_PASSCODE_VALIDATED,
    value: true,
  };
}

export function unsetPasscodeValidated() {
  return {
    type: actions.SET_PASSCODE_VALIDATED,
    value: false,
  };
}

export function setAdminPasscode(passcode) {
  return {
    type: actions.SET_ADMIN_PASSCODE,
    value: passcode,
  };
}

export function clearAdminPasscode() {
  return {
    type: actions.SET_ADMIN_PASSCODE,
    value: '',
  };
}

export function setFirstTimeClockingIn() {
  return {
    type: actions.SET_FIRST_TIME_CLOCKING_IN,
    value: true,
  };
}

export function clearFirstTimeClockingIn() {
  return {
    type: actions.SET_FIRST_TIME_CLOCKING_IN,
    value: false,
  };
}

export function setMagicLink(link) {
  return {
    type: actions.SET_MAGIC_LINK,
    value: link,
  };
}



// WEBPACK FOOTER //
// ./src/store/config/actions.js